import React from "react";

const WHATSAPP_NUMBER = "+918489245920";

const GREETING_MESSAGE = "Hello, I would like to make an enquiry about the houseboat stays.";

const WhatsAppChatButton = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent(GREETING_MESSAGE);

    const webUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    const appUrl = `whatsapp://send?phone=${WHATSAPP_NUMBER}&text=${message}`;

    const isMobile =
      /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    if (isMobile) {
      window.location.href = appUrl;
      setTimeout(() => {
        window.open(webUrl, "_blank");
      }, 1500);
    } else {
      window.open(webUrl, "_blank");
    }
  };

  return (
    <div
      onClick={openWhatsApp}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#25D366",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
        zIndex: 1000,
        transition: "transform 0.2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      title="Chat on WhatsApp"
    >
      {/* WhatsApp Icon (SVG) */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M20.52 3.48A11.91 11.91 0 0012 .01C5.37.01.01 5.37.01 12c0 2.11.55 4.09 1.6 5.85L.01 24l6.48-1.62A11.94 11.94 0 0012 24c6.63 0 11.99-5.37 11.99-12 0-3.2-1.25-6.21-3.47-8.52zm-8.52 18c-1.98 0-3.92-.53-5.59-1.53l-.4-.24-3.85 1.02 1.03-3.74-.26-.41A9.952 9.952 0 012 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.32-7.47c-.28-.14-1.64-.81-1.9-.9-.26-.09-.45-.14-.64.14-.19.28-.74.9-.91 1.08-.17.19-.33.21-.61.07-.28-.14-1.18-.43-2.25-1.39-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.12-.12.28-.31.42-.46.14-.14.19-.24.28-.4.09-.16.05-.3-.02-.44-.07-.14-.64-1.55-.88-2.13-.23-.56-.47-.48-.64-.49-.16-.01-.35-.01-.54-.01s-.42.06-.64.3c-.22.24-.83.81-.83 1.97s.85 2.28.97 2.44c.12.16 1.66 2.54 4.03 3.56.56.24 1 .38 1.34.49.56.18 1.07.15 1.48.09.45-.07 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.07-.12-.26-.19-.54-.33z" />
      </svg>
    </div>
  );
};

export default WhatsAppChatButton;
